import { useQuery } from '@apollo/client';

import type {
  GetWidgetSessionBySessionIdQuery as Query,
  GetWidgetSessionBySessionIdQueryVariables as Variables,
} from 'bundles/widget/queries/__generated__/getWidgetSession';
import GetWidgetSessionQuery from 'bundles/widget/queries/getWidgetSession.graphql';

export const useWidgetSessionQuery = ({ sessionId }: { sessionId?: string }) => {
  const { data, refetch } = useQuery<Query, Variables>(GetWidgetSessionQuery, {
    variables: { sessionId: sessionId ?? '' },
    skip: !sessionId,
    context: { clientName: 'gatewayGql' },
  });

  const convertApiResponseToExistingWidgetFormat = (responseData: Query | undefined) => {
    const widgetSessionData = responseData?.WidgetSessions?.queryWidgetSessionBySessionId;
    if (!widgetSessionData) {
      return null;
    }

    const widgetSessionFromData = {
      src: widgetSessionData?.src,
      sandbox: widgetSessionData?.sandbox ?? '',
      iframeTitle: widgetSessionData?.iframeTitle ?? '',
      rpcActionTypes: widgetSessionData?.rpcActionTypes,
      configuration: widgetSessionData?.configuration?.data,
      expiresAt: widgetSessionData?.expiresAt,
      id: widgetSessionData?.id,
    };
    return widgetSessionFromData;
  };

  return {
    fetchWidgetSession: refetch,
    widgetSession: convertApiResponseToExistingWidgetFormat(data),
  };
};
